export const SUCCESS_HTTP_CODES = [200, 201, 202, 204];
